class FeaturedProduct extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const mainImage = this.getAttribute("main-image")
        const templateElement = document
            .querySelector("#featured-product")
            .content.cloneNode(true)

        const productId = this.getAttribute("product-id")
        templateElement.querySelector("[main-image]").src = mainImage
        if (this.hasAttribute("reverse")) {
            templateElement
                .querySelector("[root]")
                .classList.remove("lg:flex-row", "flex-col")
            templateElement
                .querySelector("[root]")
                .classList.add("lg:flex-row-reverse", "flex-col-reverse")
        }
        this.fetchProduct(productId).then((product) => {
            if (productId && product) {
                this.attachCTA(product, templateElement)
                this.appendChild(templateElement)
            } else {
                this.classList.add("media")
                this.appendChild(templateElement)
            }
        })
    }

    attachCTA(product, templateElement) {
        const productLink = product
            ? product.link || product.url || "#"
            : this.getAttribute("product-link") || "#"
        const productImage = product
            ? product.images[0].src
            : this.getAttribute("product-image") || ""
        const productTitle = product
            ? product.title || product.name || ""
            : this.getAttribute("product-title") || ""
        const productPrice = product
            ? `${Shopify.currency.active} ${product.variants[0].price}`
            : this.getAttribute("product-price") || ""

        templateElement.querySelector("[product-link]").href = productLink

        templateElement.querySelector("[product-image]").src = productImage
        templateElement.querySelector("[product-title]").textContent =
            productTitle
        templateElement.querySelector("[product-price]").textContent =
            productPrice
    }

    async fetchProduct(productId) {
        const url = `${Shopify.routes.root}products.json`
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`HTTP ${response.status} fetching ${url}`)
        }
        const products = (await response.json()).products
        return products.find((p) => String(p.id) === String(productId))
    }
}

{
    /* <div style="max-width:none !important;">
  <featured-product  main-image="https://cdn.shopify.com/s/files/1/0939/6702/4393/files/Ageless_Night_Cream.png?v=1776360209" product-link="https://39bc.myshopify.com/products/denarii-oil-body-cleanser" product-price="45.95 EUR" product-image="https://cdn.shopify.com/s/files/1/0939/6702/4393/files/Ageless_Night_Cream_fd28defb-748e-4a4a-9b76-fe1174c4bcd1.png?v=1777926881" product-title="DENARII OIL BODY CLEANSER"></featured-product>
</div> */
}

class ProductAddOn extends HTMLElement {
    constructor() {
        super()
    }

    async connectedCallback() {
        const productId = this.getAttribute("product-id")
        const mainImage = this.getAttribute("main-image")

        const templateElement = document
            .querySelector("#product-addon")
            .content.cloneNode(true)

        templateElement.querySelector("[main-image]").src = mainImage
        this.appendChild(templateElement)

        if (!productId) {
            this.classList.add("media")
            return
        }

        try {
            this.product = await this.fetchProduct(productId)
            if (this.product) {
                this.populateProduct(this.product)
                this.bindAddToCart()
            } else {
                this.classList.add("media")
            }
        } catch (error) {
            console.error(
                `ProductAddOn: failed to load product ${productId}`,
                error
            )
            this.classList.add("media")
        }
    }

    async fetchProduct(productId) {
        const url = `${Shopify.routes.root}products.json`
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`HTTP ${response.status} fetching ${url}`)
        }
        const products = (await response.json()).products
        return products.find((p) => String(p.id) === String(productId))
    }

    populateProduct(product) {
        const titleEl = this.querySelector("[product-title]")
        const imageEl = this.querySelector("[product-image]")
        const priceEl = this.querySelector("[product-price]")
        const linkEl = this.querySelector("[product-redirect]")

        if (linkEl) {
            linkEl.href = this.getAttribute("product-url") || "#"
        }

        if (titleEl) {
            titleEl.href = product.link || product.url || "#"
            titleEl.textContent = product.title || product.name || ""
        }
        if (imageEl) {
            imageEl.src = product.images[0].src
            imageEl.alt = product.title || product.name || ""
        }
        if (priceEl) {
            priceEl.textContent = `${Shopify.currency.active} ${product.variants[0].price}`
        }
    }

    bindAddToCart() {
        const addBtn = this.querySelector("[add-to-cart]")
        if (!addBtn) return

        addBtn.addEventListener("click", (e) => {
            e.preventDefault()
            this.addToCart()
        })
    }

    async addToCart() {
        const addBtn = this.querySelector("[add-to-cart]")
        const variantId = this.product.variants[0].id

        const originalText = addBtn?.textContent
        if (addBtn) {
            addBtn.disabled = true
        }

        try {
            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    items: [{ id: variantId, quantity: 1 }],
                }),
            })

            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({}))
                throw new Error(
                    errorBody.description || `HTTP ${response.status}`
                )
            }

            const result = await response.json()

            // Notify the rest of the theme so the cart drawer / count can update
            document.dispatchEvent(
                new CustomEvent("cart:updated", {
                    bubbles: true,
                    detail: { items: result.items || [result] },
                })
            )

            if (addBtn) {
                setTimeout(() => {
                    addBtn.disabled = false

                    location.href = "/checkout"
                }, 1500)
            }
        } catch (error) {
            console.error("ProductAddOn: add to cart failed", error)
            if (addBtn) {
                addBtn.disabled = false
            }
        }
    }
}

customElements.define("product-addon", ProductAddOn)
customElements.define("featured-product", FeaturedProduct)
